// extracted by mini-css-extract-plugin
export default {"Section":"AppOptions_Section__5VPbU","WithTopLine":"AppOptions_WithTopLine__AC6E+"};